module.exports = __webpack_public_path__ + "img/MY.af41aeb8.webp";